import React from "react";
export default ({ event, title }) => (
    <button
        title={title || "Excluir"}
        type="button"
        className="botao-excluir"
        style={{
            width: 20,
            height: 20,
            padding: "0 3px",
            border: "none",
            outline: "none",
            borderRadius: "0.3rem",
        }}
        onClick={event}
    >
        <i className="fas fa-times" />
    </button>
);
